import axios from 'axios';
import router from '../router';
import i18n from '../plugins/i18n';

const contentService = axios.create({
    baseURL: i18n.t('app.content_service')
});

contentService.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');
        if (token && config.url !== 'auth/authenticate') {
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

contentService.interceptors.response.use(
    (response) => { 
        return response;
    }, 
    (error) => {
        // log user out on 401
        if (!error.response) {
            // Handle network errors
            return Promise.reject(error);
        }
        if (error.response.status === 401) {
            localStorage.setItem("loggedUser", false);
            localStorage.removeItem('token');
            
            if (router.history.current.name !== "login") {
                router.push({ name: 'login', query: { nextUrl: router.history.current.name } });
            }
        }
        return Promise.reject(error);
    }
);

export default contentService;